export default __webpack_public_path__ + "static/media/idcard2.95adbb37.png";